module.exports = {
    rootUrl: process.env.REACT_APP_API_URL,
    googleMaps: process.env.REACT_APP_GMAPS_API_KEY
}